import React from 'react'
import { OutlineMinusIcon, OutlinePlusIcon } from 'assets'
import { constants } from 'helpers'

type BulkEnrollmentQuantityStepperProps = {
    quantity: number
    min?: number
    label: string
    onChange: (quantity: number) => void
    compactAdd?: boolean
    disabled?: boolean
}

export const BulkEnrollmentQuantityStepper = ({
    quantity,
    min = 0,
    label,
    onChange,
    compactAdd = false,
    disabled = false
}: BulkEnrollmentQuantityStepperProps) => {
    if (quantity < 1 && compactAdd) {
        return (
            <button
                type="button"
                className="bulk-enrollment-stepper__add"
                aria-label={`Ajouter ${label}`}
                disabled={disabled}
                onClick={() => {
                    if (disabled) return
                    onChange(1)
                }}
            >
                <OutlinePlusIcon
                    color="#fff"
                    width="12"
                    height="12"
                    strokeWidth="3"
                />
            </button>
        )
    }

    return (
        <div className="bulk-enrollment-stepper">
            <button
                type="button"
                className="bulk-enrollment-stepper__step bulk-enrollment-stepper__step--minus"
                aria-label={`Diminuer ${label}`}
                disabled={disabled || quantity <= min}
                onClick={() => {
                    if (disabled || quantity <= min) return
                    onChange(quantity - 1)
                }}
            >
                <OutlineMinusIcon
                    color="#231F20"
                    width="12"
                    height="12"
                    strokeWidth="3"
                />
            </button>
            <span className="bulk-enrollment-stepper__qty">{quantity}</span>
            <button
                type="button"
                className="bulk-enrollment-stepper__step bulk-enrollment-stepper__step--plus"
                aria-label={`Augmenter ${label}`}
                disabled={
                    disabled || quantity >= constants.MAX_ORDER_OF_PACKAGE
                }
                onClick={() => {
                    if (
                        disabled ||
                        quantity >= constants.MAX_ORDER_OF_PACKAGE
                    ) {
                        return
                    }
                    onChange(quantity + 1)
                }}
            >
                <OutlinePlusIcon
                    color="#fff"
                    width="12"
                    height="12"
                    strokeWidth="3"
                />
            </button>
        </div>
    )
}
